import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { RedirectPqrListActionsProps } from './props';
import { useRedirectPqrListActions } from './hook';

export const RedirectPqrListActions = ({ id }: RedirectPqrListActionsProps) => {
    const { handleEdit } = useRedirectPqrListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
